export enum ESkillLevel {
  MIN_LEVEL = 0,
  MAX_LEVEL = 4
}
